module.exports = __webpack_public_path__ + "img/Slide1.f6758e5e.jpg";